import React from 'react';

import {TeamPageFilterBarStructure} from 'app/teams/components/TeamDetailPage/components/TeamPageFilterBarStructure';
import {gt} from 'app/utils/i18n';

import {AddNewTeamMemberButton} from './AddNewTeamMemberButton';
import {AddNewTeamRoleButton} from './AddNewTeamRoleButton';

import type {TeamSerializedType} from 'sweet-types';

type Props = {
  team: TeamSerializedType;
  showingRoles: string | number | boolean;
  setShowRoles: (arg: boolean) => unknown;
};

export const MembersListOptionsBar = ({
  team,
  showingRoles,
  setShowRoles,
}: Props) => (
  <TeamPageFilterBarStructure>
    <div className="mb-2 mb-sm-0 col-12 col-sm-6 col-md-4 col-lg-3">
      <select
        className="form-control"
        value={showingRoles ? 'roles' : 'users'}
        onChange={(e) => setShowRoles(e.target.value === 'roles')}
      >
        <option value="roles">{gt('Sort by Role')}</option>
        <option value="users">{gt('Sort by Name')}</option>
      </select>
    </div>
    {team.can_edit ? (
      <div className="ml-auto col-auto align-items-center d-flex">
        <span className="mr-2">{gt('Add')}</span>
        <div className="btn-group">
          <AddNewTeamRoleButton team={team} />
          <AddNewTeamMemberButton team={team} />
        </div>
      </div>
    ) : null}
  </TeamPageFilterBarStructure>
);
